export default __webpack_public_path__ + "static/media/gd.e57191be.jpg";